"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagKR = function FlagKR(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M51-46.59A70.63,70.63,0,0,0-46.89-27a35.28,35.28,0,0,0,9.78,49,35.26,35.26,0,0,0,48.93-9.8A35.29,35.29,0,1,1,70.54,51.32,70.6,70.6,0,0,0,51-46.59",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-46.9-27a35.3,35.3,0,0,0,9.79,49,35.27,35.27,0,0,0,48.93-9.81A35.29,35.29,0,1,1,70.54,51.32,70.58,70.58,0,1,1-46.9-27",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M86.94-73.27,99.77-54a3.54,3.54,0,0,1-1,4.89l-3.25,2.18a3.53,3.53,0,0,1-4.91-1L77.79-67.17a3.53,3.53,0,0,1,1-4.9L82-74.25a3.54,3.54,0,0,1,4.91,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M106.73-43.54,119.6-24.27a3.54,3.54,0,0,1-1,4.91l-3.27,2.16a3.53,3.53,0,0,1-4.88-1L97.6-37.44a3.53,3.53,0,0,1,1-4.9l3.26-2.17a3.53,3.53,0,0,1,4.9,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M100.67-82.43l32.67,49a3.54,3.54,0,0,1-1,4.89l-3.29,2.19a3.53,3.53,0,0,1-4.89-1l-32.68-49a3.54,3.54,0,0,1,1-4.9l3.29-2.18a3.52,3.52,0,0,1,4.9,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.37-91.59l12.86,19.32a3.53,3.53,0,0,1-1,4.9L123-65.21a3.52,3.52,0,0,1-4.88-1l-12.87-19.3a3.53,3.53,0,0,1,1-4.89l3.28-2.19a3.54,3.54,0,0,1,4.9,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M134.17-61.8,147-42.52a3.54,3.54,0,0,1-1,4.9l-3.26,2.17a3.53,3.53,0,0,1-4.9-1L125-55.7a3.54,3.54,0,0,1,1-4.89l3.26-2.18a3.53,3.53,0,0,1,4.9,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-86.82,42.57l32.66,49a3.54,3.54,0,0,1-1,4.9l-3.27,2.18a3.53,3.53,0,0,1-4.9-1L-96,48.67a3.54,3.54,0,0,1,1-4.9l3.27-2.18a3.52,3.52,0,0,1,4.9,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-100.54,51.73-87.71,71a3.53,3.53,0,0,1-1,4.89L-91.94,78a3.53,3.53,0,0,1-4.9-1l-12.84-19.22a3.54,3.54,0,0,1,1-4.9l3.27-2.18a3.51,3.51,0,0,1,4.89,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80.72,81.46l12.84,19.29a3.53,3.53,0,0,1-1,4.89l-3.26,2.18a3.54,3.54,0,0,1-4.9-1L-89.87,87.56a3.53,3.53,0,0,1,1-4.89l3.27-2.19a3.54,3.54,0,0,1,4.9,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-114.25,60.88l32.64,49a3.53,3.53,0,0,1-1,4.89l-3.26,2.19a3.55,3.55,0,0,1-4.91-1L-123.4,67a3.53,3.53,0,0,1,1-4.9l3.28-2.19a3.53,3.53,0,0,1,4.89,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-96-24.27l32.66-49a3.52,3.52,0,0,1,4.9-1l3.27,2.18a3.54,3.54,0,0,1,1,4.9l-32.67,49a3.53,3.53,0,0,1-4.89,1L-95-19.36a3.54,3.54,0,0,1-1-4.91Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-109.68-33.41l32.66-49a3.54,3.54,0,0,1,4.9-1l3.26,2.18a3.55,3.55,0,0,1,1,4.9l-32.66,49a3.52,3.52,0,0,1-4.89,1l-3.27-2.18a3.53,3.53,0,0,1-1-4.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-123.41-42.52l32.66-49.07a3.54,3.54,0,0,1,4.91-1l3.26,2.18a3.52,3.52,0,0,1,1,4.89l-32.64,49.07a3.54,3.54,0,0,1-4.9,1l-3.28-2.18a3.54,3.54,0,0,1-1-4.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M77.79,91.53,90.63,72.3a3.53,3.53,0,0,1,4.9-1l3.25,2.18a3.53,3.53,0,0,1,1,4.89L86.94,97.63a3.53,3.53,0,0,1-4.9,1l-3.27-2.18a3.54,3.54,0,0,1-1-4.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M97.59,61.89l12.86-19.32a3.53,3.53,0,0,1,4.9-1l3.28,2.18a3.54,3.54,0,0,1,1,4.9L106.72,68a3.53,3.53,0,0,1-4.89,1l-3.24-2.15a3.53,3.53,0,0,1-1-4.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M91.5,100.74l12.85-19.28a3.53,3.53,0,0,1,4.89-1l3.29,2.19a3.54,3.54,0,0,1,1,4.9l-12.84,19.27a3.53,3.53,0,0,1-4.9,1l-3.29-2.19a3.54,3.54,0,0,1-1-4.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M111.32,71l12.86-19.24a3.53,3.53,0,0,1,4.89-1l3.28,2.19a3.53,3.53,0,0,1,1,4.9L120.48,77.06a3.53,3.53,0,0,1-4.9,1l-3.28-2.18a3.54,3.54,0,0,1-1-4.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M105.21,109.84,118.08,90.6a3.52,3.52,0,0,1,4.88-1l3.27,2.16a3.53,3.53,0,0,1,1,4.9L114.37,116a3.54,3.54,0,0,1-4.9,1l-3.28-2.18a3.55,3.55,0,0,1-1-4.91Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M125,80.16l12.83-19.27a3.52,3.52,0,0,1,4.9-1L146,62.09A3.52,3.52,0,0,1,147,67L134.16,86.22a3.52,3.52,0,0,1-4.88,1L126,85.05a3.52,3.52,0,0,1-1-4.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagKR;
exports["default"] = _default;